<template>
  <div class="roles-main">
    <el-row>
      <el-col v-loading="uiControl.profitLoading">
        <div class="clearfix" v-if="parseInt(store.state.user.siteId) !== 37">
          <span class="role-span htitle">
            {{ $t('fields.monthlyMemberCommission') }}
          </span>
        </div>
        <div class="clearfix" v-else>
          <el-card>
            <el-row>
              <el-radio-group
                v-model="showLottery"
                size="large"
                @change="changeType"
              >
                <el-radio-button label="false">
                  {{ $t('fields.othersCommissionData') }}
                </el-radio-button>
                <el-radio-button label="true">
                  {{ $t('fields.lotteryCommissionData') }}
                </el-radio-button>
              </el-radio-group>
            </el-row>
            <el-row :gutter="20" class="profit-summary ph2-profit-summary">
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/profit.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.profit') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span v-formatter="{data: item.profit, type: 'money'}" />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/netprofit.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.netProfit') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span
                      v-formatter="{data: item.netProfit, type: 'money'}"
                    />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/bonus.svg">
                    </el-icon>
                    <span class="sub-title-span">{{ $t('fields.bonus') }}</span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span v-formatter="{data: item.bonus, type: 'money'}" />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/money.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.platformFee') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span
                      v-formatter="{data: item.platformFee, type: 'money'}"
                    />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/money.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.estimatedTeamCommission') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span
                      v-formatter="{
                        data: item.netProfit < 0 ? 0 : (item.netProfit * affInfo.commission).toFixed(2),
                        type: 'money',
                      }"
                    />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/money.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.estimatedDownlineCommission') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span
                      v-formatter="{
                        data: item.downlineNetProfit < 0 ? 0 : (item.downlineNetProfit).toFixed(2),
                        type: 'money',
                      }"
                    />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/payment.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.paymentFee') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span
                      v-formatter="{data: item.paymentFee, type: 'money'}"
                    />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/rebate.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.rebate') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span v-formatter="{data: item.rebate, type: 'money'}" />
                  </el-col>
                </el-row>
              </el-card>
              <el-card
                class="box-card"
                :body-style="{padding: '0px 20px 20px'}"
              >
                <template #header>
                  <div class="clearfix">
                    <el-icon>
                      <img src="../../assets/images/home/rebate.svg">
                    </el-icon>
                    <span class="sub-title-span">
                      {{ $t('fields.downlineRebate') }}
                    </span>
                  </div>
                </template>
                <el-row
                  style="margin-bottom: 10px;"
                  :class="'row-data-' + index"
                  v-for="(item, index) in memberSummary"
                  :key="item.id"
                >
                  <el-col :lg="16" class="total-title">
                    {{ t('fields.' + item.time) }}
                  </el-col>
                  <el-col :lg="8" class="total-text">
                    {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                    <span v-formatter="{data: item.downlineRebate, type: 'money'}" />
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
          </el-card>
        </div>
        <el-row
          :gutter="20"
          class="profit-summary"
          v-if="parseInt(store.state.user.siteId) !== 37"
        >
          <el-card
            class="box-card"
            :body-style="
              store.state.user.siteId.toString() === siteEnum.LK6
                ? {padding: '0px 20px 20px'}
                : {}
            "
          >
            <template
              v-if="store.state.user.siteId.toString() === siteEnum.LK6"
              #header
            >
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/profit.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.commission') }}
                </span>
              </div>
            </template>
            <div class="total">
              <el-row
                v-if="store.state.user.siteId.toString() !== siteEnum.LK6"
              >
                <el-col :lg="19" class="total-title">
                  {{ t('fields.commissionRate') }}
                </el-col>
                <el-col :lg="5" class="total-text">
                  {{ (affInfo.commission * 100).toFixed(0) }} %
                </el-col>
              </el-row>
              <el-row>
                <el-col :lg="19" class="total-title">
                  {{ t('fields.lastMonthTotal') }}
                </el-col>
                <el-col :lg="5" class="total-text">
                  {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                  <span
                    v-formatter="{
                      data: totalCommission.lastMonthTotal,
                      type: 'money',
                    }"
                  />
                </el-col>
              </el-row>
              <el-row>
                <el-col :lg="19" class="total-title">
                  {{ t('fields.monthBeforeLastTotal') }}
                </el-col>
                <el-col :lg="5" class="total-text">
                  {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                  <span
                    v-formatter="{
                      data: totalCommission.monthBeforeLastTotal,
                      type: 'money',
                    }"
                  />
                </el-col>
              </el-row>
            </div>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/profit.svg">
                </el-icon>
                <span class="sub-title-span">{{ $t('fields.profit') }}</span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.profit, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/netprofit.svg">
                </el-icon>
                <span class="sub-title-span">{{ $t('fields.netProfit') }}</span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.netProfit, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/bonus.svg">
                </el-icon>
                <span class="sub-title-span">{{ $t('fields.bonus') }}</span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.bonus, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/money.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.estimatedMemberCommission') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{
                    data: (item.netProfit * affInfo.commission).toFixed(2),
                    type: 'money',
                  }"
                />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/money.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.platformFee') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.platformFee, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/payment.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.paymentFee') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.paymentFee, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" :body-style="{padding: '0px 20px 20px'}">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/rebate.svg">
                </el-icon>
                <span class="sub-title-span">{{ $t('fields.rebate') }}</span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in memberSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.rebate, type: 'money'}" />
              </el-col>
            </el-row>
          </el-card>
        </el-row>
      </el-col>
    </el-row>

    <el-row
      style="margin-top: 20px;"
      v-loading="uiControl.commissionLoading"
      v-if="parseInt(store.state.user.siteId) !== 37"
    >
      <el-col>
        <div class="clearfix">
          <span class="role-span htitle">
            {{ $t('fields.monthlyAffiliateCommission') }}
          </span>
        </div>
        <el-row class="commission-summary">
          <el-card class="box-card">
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/money.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.estimatedAffiliateCommission') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in commissionSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{
                    data: item.estimatedCommission,
                    type: 'money',
                  }"
                />
              </el-col>
            </el-row>
          </el-card>
          <el-card
            v-if="
              affiliateLevel === 'MASTER_AFFILIATE' ||
                affiliateLevel === 'SUPER_AFFILIATE'
            "
            class="box-card"
          >
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/money.svg">
                </el-icon>
                <span
                  v-if="affiliateLevel === 'MASTER_AFFILIATE'"
                  class="sub-title-span"
                >
                  {{ $t('fields.secondLevelAffiliateCommission') }}
                </span>
                <span
                  v-else-if="affiliateLevel === 'SUPER_AFFILIATE'"
                  class="sub-title-span"
                >
                  {{ $t('fields.thirdLevelAffiliateCommission') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in commissionSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{
                    data: item.secondLevelCommission,
                    type: 'money',
                  }"
                />
              </el-col>
            </el-row>
          </el-card>
          <el-card
            v-if="affiliateLevel === 'MASTER_AFFILIATE'"
            class="box-card"
          >
            <template #header>
              <div class="clearfix">
                <el-icon>
                  <img src="../../assets/images/home/money.svg">
                </el-icon>
                <span class="sub-title-span">
                  {{ $t('fields.thirdLevelAffiliateCommission') }}
                </span>
              </div>
            </template>
            <el-row
              style="margin-bottom: 10px;"
              :class="'row-data-' + index"
              v-for="(item, index) in commissionSummary"
              :key="item.id"
            >
              <el-col :lg="16" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :lg="8" class="total-text">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{
                    data: item.thirdLevelCommission,
                    type: 'money',
                  }"
                />
              </el-col>
            </el-row>
          </el-card>
        </el-row>
      </el-col>
    </el-row>

    <!-- weekly salary, ph2 master affiliate only -->
    <el-row
      v-if="showWeeklySalary && weeklySalary.eligible"
      style="width: 100%; margin-top: 20px;"
      v-loading="uiControl.salaryLoading"
    >
      <el-col>
        <el-card class="weekly-salary">
          <div class="ws-header">
            <div>
              <div class="ws-title">
                {{ t('weeklySalary.title') }}
                <i
                  class="el-icon-question ws-help"
                  @click="uiControl.salaryRuleVisible = true"
                />
              </div>
              <div class="ws-subtitle">Agent Weekly Salary</div>
            </div>
            <el-radio-group
              v-model="salaryWeek"
              size="small"
              @change="loadWeeklySalary"
            >
              <el-radio-button label="thisWeek">
                {{ t('fields.thisWeek') }}
              </el-radio-button>
              <el-radio-button label="lastWeek">
                {{ t('fields.lastWeek') }}
              </el-radio-button>
            </el-radio-group>
          </div>

          <div class="ws-amount-row">
            <div>
              <div class="ws-label">
                {{ salaryWeek === 'thisWeek' ? t('weeklySalary.estimatedSalary') : t('weeklySalary.lastWeekSalary') }}
              </div>
              <div class="ws-amount">
                ₱{{ formatAmount(weeklySalary.salaryAmount) }}
              </div>
              <div class="ws-note">
                <template v-if="weeklySalary.estimated">
                  {{ t('weeklySalary.estimateNote') }}
                </template>
                <template v-else-if="weeklySalary.payoutStatus">
                  {{ t(`weeklySalary.payoutStatus.${weeklySalary.payoutStatus}`) }}
                </template>
              </div>
            </div>
            <div class="ws-tier">
              {{ weeklySalary.tierCode ? t(`weeklySalary.tier.${weeklySalary.tierCode}`) : t('weeklySalary.notQualified') }}
            </div>
          </div>

          <div v-for="item in salaryProgress" :key="item.key" class="ws-progress">
            <div class="ws-progress-text">
              <span>{{ item.label }}</span>
              <span>
                <b>{{ item.format(item.value) }}</b> / {{ item.format(item.target) }}
              </span>
            </div>
            <el-progress
              :percentage="item.percentage"
              :show-text="false"
              :stroke-width="8"
              color="#1f7a3a"
            />
          </div>

          <div v-if="salaryWeek === 'thisWeek' && nextTierText" class="ws-next">
            {{ nextTierText }}
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      v-model="uiControl.salaryRuleVisible"
      :title="t('weeklySalary.ruleTitle')"
      :width="isMobile ? '95%' : '760px'"
      append-to-body
    >
      <div class="ws-rule">
        <el-table :data="salaryRules" size="small" border class="ws-rule-table">
          <el-table-column :label="t('weeklySalary.tierName')" align="center" min-width="80">
            <template #default="scope">
              {{ t(`weeklySalary.tier.${scope.row.tierCode}`) }}
            </template>
          </el-table-column>
          <el-table-column :label="t('weeklySalary.activeMember')" align="center" min-width="80">
            <template #default="scope">≥{{ scope.row.activeMember }}</template>
          </el-table-column>
          <el-table-column :label="t('weeklySalary.newMember')" align="center" min-width="80">
            <template #default="scope">≥{{ scope.row.newMember }}</template>
          </el-table-column>
          <el-table-column :label="t('weeklySalary.validBet')" align="center" min-width="110">
            <template #default="scope">≥₱{{ formatAmount(scope.row.validBet) }}</template>
          </el-table-column>
          <el-table-column :label="t('weeklySalary.salary')" align="center" min-width="80">
            <template #default="scope">
              <span class="ws-rule-salary">₱{{ formatAmount(scope.row.salary) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="ws-rule-desc">
          <div class="ws-rule-desc-title">{{ t('weeklySalary.ruleDesc') }}</div>
          <ol>
            <li v-for="n in 5" :key="n">
              {{ t(`weeklySalary.rule${n}`, {
                days: activeRule.activeDays,
                bet: formatAmount(activeRule.activeValidBet),
                deposit: formatAmount(activeRule.activeDeposit),
              }) }}
            </li>
          </ol>
        </div>
      </div>
      <div class="ws-claim">
        {{ t('weeklySalary.claim') }}
        <span class="ws-telegram">@B9_GAME</span>
      </div>
    </el-dialog>

    <el-row
      style="width: 100%; margin-top: 20px;"
      v-loading="uiControl.opsLoading"
    >
      <el-col>
        <div class="clearfix" style="margin-bottom: 5px;">
          <span class="role-span htitle">
            {{ $t('fields.operationalData') }}
          </span>
        </div>
        <el-card>
          <el-row class="radiorow">
            <el-radio-group
              v-model="request.queryDate"
              size="normal"
              @change="loadOpsSummary"
            >
              <el-radio-button label="today">
                {{ t('fields.today') }}
              </el-radio-button>
              <el-radio-button label="thisMonth">
                {{ t('fields.thisMonth') }}
              </el-radio-button>
            </el-radio-group>
          </el-row>
          <span
            style="overflow: auto; width: 100%; display: block; margin: 10px auto;"
          >
            <el-row class="ops-row-header">
              <el-col :span="4" class="total-title" />
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.newUsers') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.betMembers') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.firstDepositUsers') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.depositUsers') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.transferUsers') }}
              </el-col>
            </el-row>
            <el-row
              :class="'ops-row-data-' + index"
              v-for="(item, index) in summary"
              :key="item.id"
              style="margin-bottom: 20px;"
            >
              <el-col :span="4" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :span="4" align="center">
                {{ item.registerMemberCount }}
              </el-col>
              <el-col :span="4" align="center">
                {{ item.betMemberCount }}
              </el-col>
              <el-col :span="4" align="center">
                {{ item.ftdMemberCount }}
              </el-col>
              <el-col :span="4" align="center">
                {{ item.depositMemberCount }}
              </el-col>
              <el-col :span="4" align="center">
                {{ item.affiliateTransferMemberCount }}
              </el-col>
            </el-row>
            <el-divider />
            <el-row class="ops-row-header">
              <el-col :span="4" class="total-title" />
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.profit') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.bet') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.amountOfFirstDeposit') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.depositAmount') }}
              </el-col>
              <el-col :span="4" align="center" class="total-title">
                {{ t('fields.transferAmount') }}
              </el-col>
            </el-row>
            <el-row
              :class="'ops-row-data-' + index"
              v-for="(item, index) in summary"
              :key="item.id"
              style="margin-bottom: 20px;"
            >
              <el-col :span="4" class="total-title">
                {{ t('fields.' + item.time) }}
              </el-col>
              <el-col :span="4" align="center">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.profit, type: 'money'}" />
              </el-col>
              <el-col :span="4" align="center">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.bet, type: 'money'}" />
              </el-col>
              <el-col :span="4" align="center">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span v-formatter="{data: item.ftdAmount, type: 'money'}" />
              </el-col>
              <el-col :span="4" align="center">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{data: item.depositAmount, type: 'money'}"
                />
              </el-col>
              <el-col :span="4" align="center">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                <span
                  v-formatter="{
                    data: item.affiliateTransferAmount,
                    type: 'money',
                  }"
                />
              </el-col>
            </el-row>
          </span>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="margin-top: 20px;">
      <el-row>
        <el-col>
          <AnnouncementComponent />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script setup>
import { useStore } from '@/store'
import { computed, onMounted, onUnmounted, reactive, ref } from 'vue'
import moment from 'moment'
import {
  dashboardSummary,
  getMonthCommission,
  getLastMonthCommission,
  totalCommissionSummary,
  memberCommissionSummary,
  lastMemberCommissionSummary,
} from '../../api/affiliate-summary'
import { useI18n } from 'vue-i18n'
import AnnouncementComponent from '../../views/personal/announcement/index.vue'
import { useRouter } from 'vue-router'
import { siteEnum } from '@/consts/SiteEnum'
import { getAffiliateInfo } from '../../api/affiliate'
import { getWeeklySalaryOverview, getWeeklySalaryRules } from '../../api/affiliate-weekly-salary'
const store = useStore()
const router = useRouter()
// eslint-disable-next-line
const { t, locale } = useI18n()
const uiControl = reactive({
  profitLoading: false,
  commissionLoading: false,
  opsLoading: false,
  salaryLoading: false,
  salaryRuleVisible: false,
})
const affiliateLevel = ref(null)

// weekly salary, only master affiliate of ph2 gets the salary
const showWeeklySalary = computed(() => {
  return parseInt(store.state.user.siteId) === 37 && affiliateLevel.value === 'MASTER_AFFILIATE'
})
const salaryWeek = ref('thisWeek')
// rules from backend, sorted from lowest tier for display
const salaryRules = ref([])
const activeRule = reactive({
  activeDays: 0,
  activeValidBet: 0,
  activeDeposit: 0,
})
const weeklySalary = reactive({
  eligible: false,
  estimated: true,
  activeMemberCount: 0,
  newMemberCount: 0,
  validBet: 0,
  tierCode: null,
  salaryAmount: 0,
  nextTier: null,
  activeMemberGap: 0,
  newMemberGap: 0,
  validBetGap: 0,
  payoutStatus: null,
})
const isMobile = ref(window.innerWidth < 768)

function handleResize() {
  isMobile.value = window.innerWidth < 768
}

function formatAmount(value) {
  return Number(value || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })
}

const salaryProgress = computed(() => {
  // progress against next tier, or the current (highest) tier when already at the top
  const target = weeklySalary.nextTier ||
    salaryRules.value.find(rule => rule.tierCode === weeklySalary.tierCode) ||
    {}
  // 人 unit only for chinese
  const count = value => `${formatAmount(value)}${locale.value === 'zh' ? '人' : ''}`
  const money = value => `₱${formatAmount(value)}`
  return [
    { key: 'active', label: t('weeklySalary.activeMember'), value: weeklySalary.activeMemberCount, target: target.activeMember, format: count },
    { key: 'new', label: t('weeklySalary.newMember'), value: weeklySalary.newMemberCount, target: target.newMember, format: count },
    { key: 'bet', label: t('weeklySalary.validBet'), value: weeklySalary.validBet, target: target.validBet, format: money },
  ].map(item => ({
    ...item,
    percentage: item.target ? Math.min(100, (Number(item.value || 0) / item.target) * 100) : 0,
  }))
})

const nextTierText = computed(() => {
  const next = weeklySalary.nextTier
  if (!next) {
    return weeklySalary.tierCode ? t('weeklySalary.topTier') : ''
  }
  const gaps = []
  if (weeklySalary.activeMemberGap > 0) {
    gaps.push(t('weeklySalary.gapActive', { count: weeklySalary.activeMemberGap }))
  }
  if (weeklySalary.newMemberGap > 0) {
    gaps.push(t('weeklySalary.gapNew', { count: weeklySalary.newMemberGap }))
  }
  if (weeklySalary.validBetGap > 0) {
    gaps.push(t('weeklySalary.gapBet', { amount: formatAmount(weeklySalary.validBetGap) }))
  }
  if (gaps.length === 0) {
    return ''
  }
  const gapText = gaps.length > 1
    ? gaps.slice(0, -1).join('、') + t('weeklySalary.and') + gaps[gaps.length - 1]
    : gaps[0]
  return t('weeklySalary.nextTier', {
    tier: t(`weeklySalary.tier.${next.tierCode}`),
    salary: formatAmount(next.salary),
    gap: gapText,
  })
})

async function loadWeeklySalary() {
  uiControl.salaryLoading = true
  try {
    const { data: ret } = await getWeeklySalaryOverview(salaryWeek.value === 'lastWeek')
    Object.assign(weeklySalary, {
      eligible: false,
      estimated: true,
      activeMemberCount: 0,
      newMemberCount: 0,
      validBet: 0,
      tierCode: null,
      salaryAmount: 0,
      nextTier: null,
      activeMemberGap: 0,
      newMemberGap: 0,
      validBetGap: 0,
      payoutStatus: null,
    }, ret || {})
  } finally {
    uiControl.salaryLoading = false
  }
}

async function loadWeeklySalaryRules() {
  const { data: ret } = await getWeeklySalaryRules()
  if (!ret) {
    return
  }
  activeRule.activeDays = ret.activeDays
  activeRule.activeValidBet = ret.activeValidBet
  activeRule.activeDeposit = ret.activeDeposit
  // backend returns from highest tier
  salaryRules.value = [...(ret.rules || [])].sort((a, b) => a.salary - b.salary)
}
const showLottery = ref(false)
const request = reactive({
  queryDate: 'today',
})

const totalCommission = reactive({
  commissionRate: 0,
  lastMonthTotal: 0,
  monthBeforeLastTotal: 0,
})

const affInfo = reactive({
  affiliateCode: null,
  affiliateLevel: null,
  downlineAffiliate: 0,
  downlineMember: 0,
  commission: 0,
  revenueShare: 0,
  shareRatio: [],
})

const memberSummary = reactive([
  {
    time: 'thisMonth',
    profit: 0,
    netProfit: 0,
    bonus: 0,
    commission: 0,
    platformFee: 0,
    paymentFee: 0,
    rebate: 0,
    downlineNetProfit: 0,
  },
])

const commissionSummary = reactive([
  {
    time: 'thisMonth',
    estimatedCommission: 0,
    secondLevelCommission: 0,
    thirdLevelCommission: 0,
  },
])

const summary = reactive([
  {
    time: 'today',
    id: 0,
    registerMemberCount: 0,
    betMemberCount: 0,
    ftdMemberCount: 0,
    depositMemberCount: 0,
    affiliateTransferMemberCount: 0,
    profit: 0,
    bet: 0,
    ftdAmount: 0,
    depositAmount: 0,
    affiliateTransferAmount: 0,
  },
])

async function resetSummary() {
  summary.splice(0)
}

function convertDate(date) {
  return moment(date).format('YYYY-MM-DD')
}

async function loadTotalSummary() {
  const { data: ret } = await totalCommissionSummary(
    store.state.user.id,
    store.state.user.siteId
  )
  Object.keys({ ...ret }).forEach(field => {
    if (ret[field] || ret[field] === 0) {
      totalCommission[field] = ret[field]
    }
  })
}

async function loadMemberSummary() {
  uiControl.profitLoading = true
  memberSummary.splice(0)
  loadTotalSummary()

  if (parseInt(store.state.user.siteId) !== 37) {
    const query = checkQuery('thisMonth')
    query.isLottery = showLottery.value
    const { data: ret } = await memberCommissionSummary(
      store.state.user.id,
      query
    )
    const { data: subRet } = await lastMemberCommissionSummary(
      store.state.user.id,
      store.state.user.siteId,
      showLottery.value
    )

    const summaryField = {}
    const subSummaryField = {}
    Object.keys({ ...ret }).forEach(field => {
      if (ret[field] || ret[field] === 0) {
        summaryField[field] = ret[field]
      }
    })
    Object.keys({ ...subRet }).forEach(field => {
      if (subRet[field] || subRet[field] === 0) {
        subSummaryField[field] = subRet[field]
      }
    })
    summaryField.time = 'thisMonth'
    subSummaryField.time = 'lastMonth'
    memberSummary.push(summaryField)
    memberSummary.push(subSummaryField)
    uiControl.profitLoading = false
  } else {
    let query
    let subQuery
    if (showLottery.value === true || showLottery.value === 'true') {
      const halfMonth = checkHalfMonthQuery()
      query = halfMonth.query
      subQuery = halfMonth.subQuery
    } else {
      query = checkQuery('thisMonth')
      subQuery = checkQuery('lastMonth')
    }
    query.isLottery = showLottery.value
    subQuery.isLottery = showLottery.value
    const { data: ret } = await memberCommissionSummary(
      store.state.user.id,
      query
    )
    const { data: subRet } = await memberCommissionSummary(
      store.state.user.id,
      subQuery
    )
    const summaryField = {}
    const subSummaryField = {}
    Object.keys({ ...ret }).forEach(field => {
      if (ret[field] || ret[field] === 0) {
        summaryField[field] = ret[field]
      }
    })
    Object.keys({ ...subRet }).forEach(field => {
      if (subRet[field] || subRet[field] === 0) {
        subSummaryField[field] = subRet[field]
      }
    })
    summaryField.time = 'thisPeriod'
    subSummaryField.time = 'lastPeriod'
    memberSummary.push(summaryField)
    memberSummary.push(subSummaryField)
    uiControl.profitLoading = false
  }
}

const changeType = val => {
  showLottery.value = val
  loadMemberSummary()
}

async function loadCommissionSummary() {
  uiControl.commissionLoading = true
  commissionSummary.splice(0)

  const query = checkQuery('thisMonth')
  const { data: ret } = await getMonthCommission(store.state.user.id, query)
  const { data: subRet } = await getLastMonthCommission(
    store.state.user.id,
    store.state.user.siteId
  )

  const summaryField = {}
  const subSummaryField = {}
  Object.keys({ ...ret }).forEach(field => {
    if (ret[field] || ret[field] === 0) {
      summaryField[field] = ret[field]
    }
  })
  Object.keys({ ...subRet }).forEach(field => {
    if (subRet[field] || subRet[field] === 0) {
      subSummaryField[field] = subRet[field]
    }
  })
  summaryField.time = 'thisMonth'
  subSummaryField.time = 'lastMonth'
  commissionSummary.push(summaryField)
  commissionSummary.push(subSummaryField)
  uiControl.commissionLoading = false
}

async function loadOpsSummary() {
  uiControl.opsLoading = true
  let query = {}
  let subQuery = {}
  if (request.queryDate === 'today') {
    query = checkQuery('today')
    subQuery = checkQuery('yesterday')
  } else {
    query = checkQuery('thisMonth')
    subQuery = checkQuery('lastMonth')
  }
  const { data: ret } = await dashboardSummary(store.state.user.id, query)
  const { data: subRet } = await dashboardSummary(store.state.user.id, subQuery)
  await resetSummary()
  const summaryField = {}
  const subSummaryField = {}
  Object.keys({ ...ret }).forEach(field => {
    if (ret[field] || ret[field] === 0) {
      summaryField[field] = ret[field]
    }
  })
  Object.keys({ ...subRet }).forEach(field => {
    if (subRet[field] || subRet[field] === 0) {
      subSummaryField[field] = subRet[field]
    }
  })
  if (request.queryDate === 'today') {
    summaryField.time = 'today'
    subSummaryField.time = 'yesterday'
  } else {
    summaryField.time = 'thisMonth'
    subSummaryField.time = 'lastMonth'
  }
  summary.push(summaryField)
  summary.push(subSummaryField)
  uiControl.opsLoading = false
}

function checkQuery(dateType) {
  const query = {}
  query.siteId = store.state.user.siteId
  const end = new Date()
  const start = new Date()
  if (dateType === 'today') {
    query.recordTime = [convertDate(start), convertDate(end)].join(',')
  } else if (dateType === 'yesterday') {
    start.setTime(
      moment(start)
        .subtract(1, 'days')
        .format('x')
    )
    end.setTime(
      moment(end)
        .subtract(1, 'days')
        .format('x')
    )
    query.recordTime = [convertDate(start), convertDate(end)].join(',')
  } else if (dateType === 'thisMonth') {
    start.setTime(
      moment(start)
        .startOf('month')
        .format('x')
    )
    query.recordTime = [convertDate(start), convertDate(end)].join(',')
  } else if (dateType === 'lastMonth') {
    start.setTime(
      moment(start)
        .subtract(1, 'months')
        .startOf('month')
        .format('x')
    )
    end.setTime(
      moment(end)
        .subtract(1, 'months')
        .endOf('month')
        .format('x')
    )
    query.recordTime = [convertDate(start), convertDate(end)].join(',')
  } else if (dateType === 'dayBeforeYesterday') {
    start.setTime(
      moment(start)
        .subtract(2, 'days')
        .format('x')
    )
    end.setTime(
      moment(end)
        .subtract(2, 'days')
        .format('x')
    )
    query.recordTime = [convertDate(start), convertDate(end)].join(',')
  }
  return query
}

function checkHalfMonthQuery() {
  const siteId = store.state.user.siteId
  const today = moment()
  const clampEnd = end => (end.isAfter(today, 'day') ? today : end)
  let curStart
  let curEnd
  let lastStart
  let lastEnd
  if (today.date() < 16) {
    curStart = moment().startOf('month')
    curEnd = moment().date(15)
    lastStart = moment().subtract(1, 'months').date(16)
    lastEnd = moment().subtract(1, 'months').endOf('month')
  } else {
    curStart = moment().date(16)
    curEnd = moment().endOf('month')
    lastStart = moment().startOf('month')
    lastEnd = moment().date(15)
  }
  return {
    query: {
      siteId,
      recordTime: [convertDate(curStart), convertDate(clampEnd(curEnd))].join(','),
    },
    subQuery: {
      siteId,
      recordTime: [convertDate(lastStart), convertDate(clampEnd(lastEnd))].join(','),
    },
  }
}

async function loadAffiliateInfo() {
  const { data: aff } = await getAffiliateInfo(store.state.user.id)
  Object.keys({ ...aff }).forEach(field => {
    affInfo[field] = aff[field]
  })
}

onMounted(() => {
  if (store.state.user.siteCode === 'IND') {
    router.push('/report/daily-detail')
  }
  affiliateLevel.value = store.state.user.affiliateLevel
  loadMemberSummary()
  loadCommissionSummary()
  loadOpsSummary()
  loadAffiliateInfo()
  if (showWeeklySalary.value) {
    loadWeeklySalary()
    loadWeeklySalaryRules()
  }
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.el-card {
  border: 0;
  box-shadow: none;
}
.htitle {
  font-size: 30px;
  font-weight: bold;
}
.sub-title-span {
  font-weight: bold;
}
.profit-summary {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.ph2-profit-summary {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.profit-summary .box-card {
  flex: 1;
  flex-wrap: wrap;
  box-shadow: none;
  border: 0;
}

.total {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 10px;
  /* border-left: 3px solid #f56c6c; */
  padding-left: 10px;
}

.total-title {
  color: #7d8592;
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 5px;
}
.total-text {
  color: #3f8cff;
  /* font-weight: bold; */
  font-size: 16px;
  font-weight: normal;
}

.commission-summary {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.commission-summary .box-card {
  flex: 1;
  flex-wrap: wrap;
}

.box-card i {
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: 50px;
  border-radius: 5px;
  padding: 10px;
  width: 80px;
  height: 80px; */
}
.box-card .el-card__header .clearfix {
  display: flex;
  align-items: center;
  gap: 10px;
}
.box-card .el-card__header .clearfix .el-icon {
  width: 20px;
  height: 20px;
}
.box-card .el-icon img {
  width: 100%;
  display: block;
}

.card-panel-description {
  font-weight: 700;
  margin-left: 0;
}

.card-panel-description .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
  text-align: right;
}

.card-panel-description .card-panel-link-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}

.card-panel-description .card-panel-num {
  font-size: 20px;
  float: right;
}

.row-data-0 {
  width: 100%;
  font-weight: bold;
}

.row-data-1 {
  width: 100%;
  font-weight: bold;
  color: var(--el-text-color-regular);
}
.radiorow {
  overflow: auto;
  justify-content: flex-end;
}
.ops-row-header {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 20px;
  margin-bottom: 10px;
  min-width: 800px;
}

.ops-row-data-0 {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: bold;
  min-width: 800px;
}

.ops-row-data-1 {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: bold;
  color: var(--el-text-color-regular);
  min-width: 800px;
}

.role-span {
  font-weight: bold;
}

.weekly-salary .ws-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}
.ws-title {
  font-size: 20px;
  font-weight: bold;
  color: #0a1629;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ws-help {
  color: #3f8cff;
  cursor: pointer;
}
.ws-subtitle {
  color: #7d8592;
  font-size: 13px;
}
.ws-amount-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f4f9fd;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
}
.ws-label {
  color: #7d8592;
  font-size: 14px;
}
.ws-amount {
  color: #1f7a3a;
  font-size: 28px;
  font-weight: bold;
  margin: 4px 0;
}
.ws-note {
  color: #7d8592;
  font-size: 12px;
}
.ws-tier {
  font-weight: bold;
  color: #0a1629;
  white-space: nowrap;
}
.ws-progress {
  margin-bottom: 12px;
}
.ws-progress-text {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 14px;
  color: #0a1629;
  margin-bottom: 6px;
}
.ws-progress-text span:last-child {
  color: #7d8592;
  white-space: nowrap;
}
.ws-progress-text b {
  color: #0a1629;
}
.ws-next {
  margin-top: 8px;
  font-size: 14px;
  color: #0a1629;
}
.ws-rule {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
}
.ws-rule-salary {
  color: #1f7a3a;
  font-weight: bold;
}
.ws-rule-desc {
  background: #f4f9fd;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
}
.ws-rule-desc-title {
  font-weight: bold;
  margin-bottom: 6px;
}
.ws-rule-desc ol {
  margin: 0;
  padding-left: 18px;
}
.ws-claim {
  margin-top: 16px;
  background: #fdf6e3;
  border-radius: 8px;
  padding: 12px 16px;
  color: #8a5a00;
  word-break: break-word;
}
.ws-telegram {
  display: inline-block;
  background: #d9f2df;
  color: #1f7a3a;
  font-weight: bold;
  border-radius: 12px;
  padding: 2px 10px;
}

@media (max-width: 768px) {
  .ws-rule {
    grid-template-columns: 1fr;
  }
  .ws-amount {
    font-size: 22px;
  }
}

@media (max-width: 1200px) {
  .profit-summary {
    grid-template-columns: repeat(2, 1fr);
  }
  .commission-summary {
    grid-template-columns: repeat(1, 1fr);
  }

  .column {
    margin-top: 20px;
  }
}
@media (max-width: 500px) {
  .profit-summary {
    grid-template-columns: repeat(1, 1fr);
  }
  .role-span {
    font-size: 18px;
  }
}
</style>

<style>
.role-span {
  font-size: 30px;
  color: #0a1629;
  font-weight: bold;
}
.el-radio-group {
  background: #f4f9fd;
  padding: 2px;
  border-radius: 20px;
}
.el-radio-button .el-radio-button__inner {
  background: #f4f9fd;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 20px 0 0 20px;
  border: 0;
}
.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 20px 20px 0;
  border: 0;
}
.el-loading-mask {
  background: rgb(243 248 252 / 90%) !important;
}
@media (max-width: 500px) {
  .role-span {
    font-size: 18px;
  }
}
</style>
